export default "__VITE_ASSET__YiyMtf$o__"